const slideToggle = (elem) => {
  elem.classList.toggle("hide");
};

function initializeSlideToggle() {
  document.querySelectorAll(".toggle").forEach((el) =>
    el.addEventListener("click", () => {
      let target = el.nextElementSibling;
      let icon = el.querySelector("svg");
      let container = el.closest(".accordion");

      slideToggle(target);

      if (icon) {
        icon.classList.toggle("!-rotate-90");
      }

      if (container) {
        container.classList.toggle("bg-pale-light-blue-5");
      }
    }),
  );

  document.querySelectorAll(".toggle-hide").forEach((el) =>
    el.addEventListener("click", () => {
      let target = el.closest(".slide-toggle");

      slideToggle(target);
    }),
  );
}

document.addEventListener("DOMContentLoaded", initializeSlideToggle);

document.body.addEventListener("htmx:afterSwap", () => {
  initializeSlideToggle();
});
